import {
Layout,
Typography,
Input,
Button,
Segmented,
Upload,
Alert,
Card,
Space,
Select,
Modal,
Radio,
message,
Form,
Checkbox,
Collapse,
Badge,
Cascader,
Row,
Col,
Dropdown,
Spin,
Skeleton,
Pagination
} from 'antd';
import {
  SearchOutlined,
  UploadOutlined,
  UserOutlined,
  LinkedinFilled,
  MailOutlined,
  BuildOutlined,
  DownloadOutlined,
  DownOutlined,PhoneOutlined,EnvironmentOutlined,
  CopyOutlined,
  ApartmentOutlined
  
} from '@ant-design/icons';
import { useState } from 'react';

import Sidebar from '../components/Sidebar';
import AppHeader from '../components/Header';
import { encryptData, decryptData } from '../middleware/encryption';
import titleOptions from '../data/titleOptions.json';
import regionCountryOptions from '../data/regionCountryOptions.json';
import departmentKeywords from '../data/departmentKeywords.json';
import seniorityOptions from '../data/seniorityOptions.json';

import image_illu from '../assets/finder-back.png';

const { Content } = Layout;
const { Title, Text } = Typography;

export default function Finder() {

  const [form] = Form.useForm();
  const [collapsed, setCollapsed] = useState(false);
  const [mode, setMode] = useState('company');

  // Input States
  const [domains, setDomains] = useState([]); // Used for Company Search
  const [jobTitles, setJobTitles] = useState([]);
  const [excludedJobTitles, setExcludedJobTitles] = useState([]);
  const [countries, setCountries] = useState([]);
  const [excludedCountries, setExcludedCountries] = useState([]);

const [exportType, setExportType] = useState('selected');
const [exportLoading, setExportLoading] = useState(false);
const [isExportModalVisible, setIsExportModalVisible] = useState(false);

const [includeEmail, setIncludeEmail] = useState(true);
const [includeMobile, setIncludeMobile] = useState(false);

const [exportMode,setExportMode]=useState('all');

const [copiedField,setCopiedField]=useState({});


const [names, setNames] = useState([]);
const [companies, setCompanies] = useState([]);
const [rowSelection, setRowSelection] = useState(10);

const [selectedLeadIds, setSelectedLeadIds] = useState([]);

const [exportFilters, setExportFilters] = useState(null);

  // UI States
  const [resultLoading, setResultLoading] = useState(false);
  const [error, setError] = useState('');
  const [results, setResults] = useState([]);

  const [revealedContacts,setRevealedContacts]=useState({})
const [revealingIds,setRevealingIds]=useState({})
const [selectedLead,setSelectedLead]=useState(null)

  const [totalResults, setTotalResults] = useState(0);  

  const [currentPage,setCurrentPage]=useState(1);
const [pageSize,setPageSize]=useState(10);
const [seniority,setSeniority]=useState([]);
const [departmentKeywordsSelected,setDepartmentKeywordsSelected]=useState([]);


const [departmentKeyword, setDepartmentKeyword] = useState([]);
  
  // Usage tracking mock
  const [remaining, setRemaining] = useState(10); 

  const [isSelectAllModalVisible,setIsSelectAllModalVisible]=useState(false);

const [selectMode,setSelectMode]=useState("page");

const [selectLeadCount,setSelectLeadCount]=useState(100);

const [selectLoading,setSelectLoading]=useState(false);

  
  const updateUsage = () => setRemaining(prev => prev - 1);

  const API_URL = 'https://api.app.exellius.com/api/leads/getPeopleLeads/';






  const copyText=(text,key)=>{

navigator.clipboard.writeText(text);

setCopiedField(prev=>({
...prev,
[key]:true
}));

setTimeout(()=>{

setCopiedField(prev=>({
...prev,
[key]:false
}));

},1500);

};





  const handleReveal = async (
id,
field,
originalValue
) => {

if(
revealedContacts[id]?.[field]
) return;


setRevealingIds(prev=>({

...prev,

[id]:{

...prev[id],

[field]:true

}

}))


try{

setSelectedLead(
results.find(
lead=>lead.id===id
)
)


const token =
sessionStorage.getItem(
'access_token'
)

const credit_deduct =
field==="email"
? 1
: 5


const response =
await fetch(
"https://api.app.exellius.com/api/leads/deductCreditsFromUser",
{

method:"POST",

headers:{

"Content-Type":
"application/json",

Authorization:
`Bearer ${token}`

},

body:JSON.stringify({

count:
credit_deduct

})

}

)

const result =
await response.json()


if(response.ok){

setRevealedContacts(
prev=>({

...prev,

[id]:{

...prev[id],

[field]:
originalValue

}

})
)


}else{

message.warning(
"You do not have enough credits"
)

}

}catch(err){

message.error(
"Something went wrong"
)

}finally{

setRevealingIds(
prev=>({

...prev,

[id]:{

...prev[id],

[field]:false

}

})
)

}

}

  /* =======================
     1. COMPANY SEARCH LOGIC
  ======================= */

  // Helper: Find node in options tree based on a path
const findNodeByPath = (options, path) => {
  let node = null;
  let current = options;
  for (let i = 0; i < path.length; i++) {
    node = current.find(opt => opt.value === path[i]);
    if (!node) return null;
    current = node.children || [];
  }
  return node;
};

const collectLeafValues = (node) => {
  if (!node.children || node.children.length === 0) {
    return [node.value];
  }
  return node.children.flatMap(collectLeafValues);
};

const expandCascaderFieldToLeaves = (pathsArray, optionsTree) => {
  if (!Array.isArray(pathsArray)) return [];
  const allLeaves = [];
  pathsArray.forEach(path => {
    const node = findNodeByPath(optionsTree, path);
    if (node) {
      if (node.children && node.children.length > 0) {
        allLeaves.push(...collectLeafValues(node));
      } else {
        allLeaves.push(node.value);
      }
    }
  });
  return Array.from(new Set(allLeaves)); // No duplicates
};

const buildSearchFilters = (overrides = {}) => {
  const currentDomains = overrides.domains ?? domains;
  const currentJobTitles = overrides.jobTitles ?? jobTitles;
  const currentExcludedJobTitles = overrides.excludedJobTitles ?? excludedJobTitles;
  const currentCountries =
overrides.countries ?? countries;

const currentSeniority =
overrides.seniority ?? seniority;

const currentDepartment =
overrides.departmentKeywords ??
departmentKeywordsSelected;
  const currentExcludedCountries = overrides.excludedCountries ?? excludedCountries;

  const expandedCountries = expandCascaderFieldToLeaves(currentCountries, regionCountryOptions);
  const expandedExcludedCountries = expandCascaderFieldToLeaves(currentExcludedCountries, regionCountryOptions);

  return {
    includeIndustry: [],
    excludeIndustry: [],
    includeemployeeCount: [],
    includeRevenue: [],
    
    includeCompany: currentDomains,
    excludeCompany: [],
    includedepartmentKeyword:

expandCascaderFieldToLeaves(
currentDepartment,
departmentKeywords
),

includemanagmentRole:
currentSeniority,
    includePersonalCountry: expandedCountries,
    excludePersonalCountry: expandedExcludedCountries,
    includecompanyLocation: [],
    excludeCompanyLocation: [],
    includejobTitles: currentJobTitles,
    excludeJobTitles: currentExcludedJobTitles,
    includetechnology: [],
    foundingYear: [],
    funding: [],
    perCompany: 1,
  };
};

  const extractDomains = (text) => {
  const matches = text.match(/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}/g);
  return matches ? [...new Set(matches.map(d => d.toLowerCase()))] : [];
};

const handleFileUpload = (file) => {
  const reader = new FileReader();

  reader.onload = (e) => {
    const text = e.target.result;
    const extracted = extractDomains(text);

    setDomains((prev) => [...new Set([...prev, ...extracted])]);
  };

  reader.readAsText(file);
  return false; // prevent auto upload
};

  const handleSearch = async (overrides = {}) => {
  const currentDomains = overrides.domains ?? domains;
  if (!currentDomains || currentDomains.length === 0) {
    setError("Please enter at least one company domain.");
    return;
  }

  // domain validation regex
  const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

  const validDomains = [];
  const invalidDomains = [];

  currentDomains.forEach((d) => {
    const domain = d.trim().toLowerCase();
    if (domainRegex.test(domain)) {
      validDomains.push(domain);
    } else {
      invalidDomains.push(domain);
    }
  });

  if (validDomains.length === 0) {
    setError("No valid domains found. Please check your input.");
    return;
  }

  if (invalidDomains.length > 0) {
    setError(
      `These domains are invalid and were ignored: ${invalidDomains.join(', ')}`
    );
  } else {
    setError('');
  }

  setResultLoading(true);
  setResults([]);

  const filters = buildSearchFilters({
    domains: validDomains,
    ...overrides,
  });

  console.log("Search filters:", filters);

  setExportFilters(filters);

  try {
    const token = sessionStorage.getItem('access_token');

    const encrypted = encryptData({
      ...filters,
      page: overrides.page || currentPage,
limit: overrides.limit || pageSize,
      sort_by: 'first_name',
      sort_order: 'asc',
    });

    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ data: encrypted }),
    });

    const result = await response.json();
    const decrypted = decryptData(result.data);

     console.log(decrypted);
setTotalResults(decrypted.total_count || 0);  
    setResults(decrypted?.data || []);
  } catch (err) {
    console.error(err);
    setError("Failed to fetch company leads.");
  } finally {
    setResultLoading(false);
  }
};

const executeSearch = (overrides = {}) => {
  if (mode === 'name') {
    handleNameSearch(overrides);
  } else {
    handleSearch(overrides);
  }
};


  /* =======================
     2. NAME SEARCH LOGIC
  ======================= */


const handleEmailFinderCSV = async (file) => {
  const text = await file.text();
  const rows = text.split('\n').slice(1);

  const newNames = [];
  const newCompanies = [];

  rows.forEach(row => {
    const [name, company] = row.split(',').map(v => v?.trim());
    if (name) newNames.push(name);
    if (company) newCompanies.push(company);
  });

  setNames(prev => [...new Set([...prev, ...newNames])]);
  setCompanies(prev => [...new Set([...prev, ...newCompanies])]);

  return false; // prevent upload
};




const handleNameSearch = async (overrides = {}) => {
  if (remaining <= 0) {
    setError(
      "You’ve reached your daily limit. Please try again tomorrow or upgrade your plan."
    );
    return;
  }

  if (!names || names.length === 0) {
    setError("Please enter at least one full name.");
    return;
  }

  if (!companies || companies.length === 0) {
    setError("Please enter at least one company domain.");
    return;
  }

  setError("");
  setResultLoading(true);
  setResults([]);

  const namePairs = [];

  // 👉 Map names with companies (1–1 or fallback to first company)
  names.forEach((fullName, index) => {
    const cleanName = fullName.trim();
    if (!cleanName) return;

    const parts = cleanName.split(" ");
    if (parts.length < 2) return;

    namePairs.push({
      firstName: parts[0],
      lastName: parts.slice(1).join(" "),
      company: companies[index] || companies[0],
    });
  });

  if (namePairs.length === 0) {
    setError("No valid full names found. Use First + Last name.");
    setResultLoading(false);
    return;
  }

  try {
    const token = sessionStorage.getItem("access_token");

    const filters = {
      ...buildSearchFilters(overrides),
      includeCompany: namePairs.map(p => p.company),
      // 👇 BULK NAME SEARCH
      includeFirstName: namePairs.map(p => p.firstName),
      includeLastName: namePairs.map(p => p.lastName),
    };

    setExportFilters(filters);

    const encrypted = encryptData({
      ...filters,
      page: overrides.page || currentPage,
limit: overrides.limit || pageSize,
      sort_by: "first_name",
      sort_order: "asc",
    });

    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ data: encrypted }),
    });

    const result = await response.json();
    const decrypted = decryptData(result.data);

   
setTotalResults(decrypted.total_count || 0);  
    setResults(decrypted?.data || []);
    setRemaining(prev => Math.max(prev - namePairs.length, 0));
  } catch (err) {
    console.error("Name search error:", err);
    setError("Failed to fetch leads by name.");
  } finally {
    setResultLoading(false);
  }
};


const handleOk = () => {
  if (!exportFilters) {
    message.error('No search data available to export.');
    return;
  }

  setExportLoading(true);

  const token = sessionStorage.getItem('access_token');
  const endpoint =
    'https://api.app.exellius.com/api/leads/exportPeopleLeadsToCSV';

  const payload = {
    ...exportFilters,
    limit: rowSelection,
    getSelected: selectedLeadIds,
    leadsId: exportMode === 'selected' ? selectedLeadIds : undefined,
    includeEmail,
    includeMobile,
  };

  const encrypted = encryptData(payload);

  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ data: encrypted }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Insufficient credits in your account');
      }
      return response.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: 'text/csv;charset=utf-8;' })
      );

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'exported-leads.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setIsExportModalVisible(false);
      setExportLoading(false);
    })
    .catch((error) => {
      console.error('Export failed:', error.message);
      message.error(error.message);
      setExportLoading(false);
    });
};


const handleDepartmentKeywordChange=(value)=>{

setDepartmentKeywordsSelected(value);

if(
domains.length>0 ||
companies.length>0
){

setCurrentPage(1);

executeSearch({

departmentKeywords:value,
page:1

});

}


};

const handleSelectAllOk = async () => {

  

if(selectMode==="page"){

const visibleLeadIds =
results.map(
lead=>lead.id
);

const allSelected =
visibleLeadIds.every(
id=>selectedLeadIds.includes(id)
);

if(allSelected){

setSelectedLeadIds(prev=>
prev.filter(
id=>!visibleLeadIds.includes(id)
)
);

}else{

setSelectedLeadIds(prev=>[
...new Set([
...prev,
...visibleLeadIds
])
]);

}

setIsSelectAllModalVisible(false);

return;

}


try{

setSelectLoading(true);

const token =
sessionStorage.getItem(
'access_token'
);

const raw={
  type:"people",

filters:exportFilters,

rowSelection:
selectLeadCount,

};

const response=
await fetch(
"https://api.app.exellius.com/api/leads/getselectedLeads/",
{

method:"POST",

headers:{

"Content-Type":
"application/json",

Authorization:
`Bearer ${token}`

},

body:JSON.stringify({

data:
encryptData(raw)

})

}

);

const result=
await response.json();

console.log(result);

if(response.ok){

const decrypted =
decryptData(
result.data
);

setSelectedLeadIds(
decrypted.leadIds || []
);

message.success(
`${decrypted.leadIds.length} leads selected`
);

}else{

message.error(
result.message
);

}

}catch(err){

message.error(
"Selection failed"
);

}

finally{

setSelectLoading(false);

setIsSelectAllModalVisible(false);

}

};


const departmentCount =
departmentKeyword?.reduce(
(total,item)=>total + item.length,
0
) || 0;

const jobTitleBadgeCount =
jobTitles.length +
excludedJobTitles.length +
seniority.length +
departmentCount;

  return (
    <Layout style={{ minHeight: '125vh' }}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout>
        <AppHeader />

        <Content style={{  background: '#fff',height:'100vh',overflow:"scroll" }}>
         <div
  style={{
    background: 'linear-gradient(135deg, #f1f6ff 0%, #fce7f3 100%)',
    
    padding: '30px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'hidden',
  }}
>
  <div style={{ flex: 1 }}>
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
  <div
    style={{
      width: 52,
      height: 52,
      borderRadius: 14,
      background: '#efe7ff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#7c3aed',
      fontSize: 22,
      flexShrink: 0,
    }}
  >
    <MailOutlined />
  </div>

  <div>
    <Typography.Title
      level={3}
      style={{
        margin: 0,
        fontWeight: 700,
        color: '#1f1f1f',
        lineHeight: 1.2,
      }}
    >
      Find email by company
    </Typography.Title>

    <Typography.Text
      style={{
        color: '#6b7280',
        fontSize: 15,
        display: 'block',
        marginTop: 8,
      }}
    >
      Enter a company domain to discover professional email addresses.
    </Typography.Text>
  </div>
</div>

    <Segmented
    className="custom-segmented"
      value={mode}
      onChange={(val) => {
        setMode(val);
        setResults([]);
        setError('');
      }}
      size="large"
      style={{
        background: '#fff',
        padding: 6,
        borderRadius: 12,
        marginTop: 24,
        
      }}
      options={[
        {
          label: (
            <div className="segment-item">
              <ApartmentOutlined />
              <span>Find email by company</span>
            </div>
          ),
          value: 'company',
        },
        {
          label: (
            <div className="segment-item">
              <UserOutlined />
              <span>Find email by name</span>
            </div>
          ),
          value: 'name',
        },
      ]}
    />
  </div>

  
</div>

          {error && <Alert type="error" message={error} style={{ marginTop: 16, marginBottom: 16 }} closable onClose={() => setError("")} />}

          <div style={{width:'80%',borderRadius:12,margin:"auto",padding:20,boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",marginTop:20,background:"#fff"}}> 

            
          {mode === 'company' && (
  <>
    <div >
      <Title level={4}>Domain Search</Title>
    </div>

    <div style={{ display: 'flex', gap: 12 }}>
      <Select
  className="select-big"
  mode="tags"
  size="large"
  style={{ flex: 1 }}
  placeholder="Enter domains (example.com) or paste multiple"
  value={domains}
  onChange={setDomains}
  tokenSeparators={[',', ' ', '\n']}
  prefix={
    <BuildOutlined
      style={{
        color: '#7c3aed',
        fontSize: 16,
        marginRight: 4,
      }}
    />
  }
/>

      <Upload
        beforeUpload={handleFileUpload}
        showUploadList={false}
        accept=".csv,.txt"
      >
        <Button size="large" icon={<UploadOutlined />} style={{height: 60,width:60}} />
      </Upload>

      <Button
        size="large"
        type="primary"
        icon={<SearchOutlined />}
       loading={resultLoading}
        onClick={()=>{
setCurrentPage(1);
handleSearch({
page:1
});
}}
        style={{height: 60,width:60}}
      />
    </div>

    
  </>
)}


         
          {mode === 'name' && (
            <>
            <div style={{ marginTop: 32 }}>
  <Title level={4}>Email Finder</Title>
</div>

<div
  style={{
    display: 'flex',
    alignItems: 'center',
    padding:2,
    
    gap:12,
    overflow: 'hidden',
  }}
>
  {/* Full Name */}
  <div className='multi-options-select' style={{display: 'flex', flex: 1, alignItems: 'center',overflow: 'hidden' }}>
  <Select
  className='select-big-multi'
    mode="tags"
    size="large"
    placeholder="Enter full name(s)"
    value={names}
    onChange={setNames}
    tokenSeparators={[',', '\n']}
    style={{ flex: 1 }}
    bordered={false}
  />

  {/* Separator */}
  <div
    style={{
      padding: '0 16px',
      borderLeft: '1px solid #d9d9d9',
      borderRight: '1px solid #d9d9d9',
      color: '#999',
    }}
  >
    @
  </div>

  {/* Company Domain */}
  <Select
  className='select-big-multi'
    mode="tags"
    size="large"
    placeholder="company.com"
    value={companies}
    onChange={setCompanies}
    tokenSeparators={[',', '\n']}
    style={{ flex: 1 }}
    bordered={false}
  />

</div>
  {/* CSV Upload */}
  <Upload
    beforeUpload={handleEmailFinderCSV}
    showUploadList={false}
    accept=".csv"
  >
    <Button size="large"   icon={<UploadOutlined />} style={{height: 60,width:60}} />
     
  </Upload>

  {/* Search */}
  <Button
    size="large"
    type="primary"
    icon={<SearchOutlined />}
    loading={resultLoading}
    onClick={()=>{
setCurrentPage(1);
handleNameSearch({
page:1
});
}}
    style={{height: 60,width:60}}
  />
</div>


             
            </>
          )}

          
        


        {(resultLoading || results?.length > 0) && (



<Space
direction="vertical"
size={24}
style={{
marginTop:24,
overflow:'scroll',
scrollbarWidth:'none',
msOverflowStyle:'none',
width:'100%'
}}
>

{/* HEADER */}

  <div
  style={{
   
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap'
  }}
>

{/* Compact Filters + Export */}

<div
style={{
display:'flex',
alignItems:'center',
width:'100%'
}}
>

{/* LEFT SIDE FILTERS */}

<div
style={{
display:'flex',
gap:12,
flexWrap:'wrap'
}}
>

{/* JOB TITLE FILTER */}

<Dropdown
trigger={['click']}
placement="bottomLeft"
dropdownRender={()=>(

<div
style={{
width:380,
padding:18,
background:'#fff',
borderRadius:12,
boxShadow:' rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px'
}}
>

<div style={{marginBottom:18}}>

<Text strong>

Seniority

</Text>

<Select

mode="multiple"

showSearch

optionFilterProp="children"

placeholder="Select Seniority"

style={{
width:'100%',
marginTop:8
}}

value={seniority}

onChange={(value)=>{

setSeniority(value)

if(
domains.length>0 ||
companies.length>0
){

setCurrentPage(1)

executeSearch({

seniority:value,
page:1

})

}

}}

>

{seniorityOptions.options.map(opt=>(

<Select.Option
key={opt.value}
value={opt.value}
>

{opt.label}

</Select.Option>

))}

</Select>

</div>



<div style={{marginBottom:18}}>

<Text strong>

Department

</Text>

<Cascader

options={departmentKeywords}

placeholder="Select Department"

multiple

showSearch

maxTagCount="responsive"

style={{
width:'100%',
marginTop:8
}}

value={departmentKeywordsSelected}

onChange={
handleDepartmentKeywordChange
}

/>

</div>



<div style={{marginBottom:18}}>

<Text strong>

Include Job Titles

</Text>

<Select

mode="tags"

style={{
width:'100%',
marginTop:8
}}

placeholder="Add titles"

value={jobTitles}

onChange={(value)=>{

setJobTitles(value)

if(
domains.length>0 ||
companies.length>0
){

setCurrentPage(1)

executeSearch({

jobTitles:value,
page:1

})

}

}}

tokenSeparators={[
',',
'\n'
]}

options={
titleOptions.options
}

/>

</div>



<div>

<Text strong>

Exclude Job Titles

</Text>

<Select

mode="tags"

style={{
width:'100%',
marginTop:8
}}

placeholder="Exclude titles"

value={excludedJobTitles}

onChange={(value)=>{

setExcludedJobTitles(value)

if(
domains.length>0 ||
companies.length>0
){

setCurrentPage(1)

executeSearch({

excludedJobTitles:value,
page:1

})

}

}}

tokenSeparators={[
',',
'\n'
]}

options={
titleOptions.options
}

/>

</div>



</div>

)}
>

<Button size="large">

Job Titles

{jobTitleBadgeCount > 0 && (

<Badge
count={jobTitleBadgeCount}
style={{
marginLeft:8,
background:'#7c3aed'
}}
/>

)}

<DownOutlined style={{marginLeft:8}} />

</Button>

</Dropdown>



{/* COUNTRY FILTER */}

<Dropdown
trigger={['click']}
placement="bottomLeft"
dropdownRender={()=>(

<div
style={{
width:380,
padding:18,
background:'#fff',
borderRadius:12,
boxShadow:' rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px'
}}
>

<div style={{marginBottom:18}}>

<Text strong>
Include Countries
</Text>

<Cascader
multiple
showSearch
maxTagCount="responsive"
style={{
width:'100%',
marginTop:8
}}
options={regionCountryOptions}
value={countries}
placeholder="Select countries"
onChange={(value)=>{

setCountries(value)

executeSearch({
countries:value
})

}}
/>

</div>

<div>

<Text strong>
Exclude Countries
</Text>

<Cascader
multiple
showSearch
maxTagCount="responsive"
style={{
width:'100%',
marginTop:8
}}
options={regionCountryOptions}
value={excludedCountries}
placeholder="Exclude countries"
onChange={(value)=>{

setExcludedCountries(value)

executeSearch({
excludedCountries:value
})

}}
/>

</div>

</div>

)}
>

<Button size="large">

Country

{(countries.length+excludedCountries.length)>0 && (

<Badge
count={countries.length+excludedCountries.length}
style={{
marginLeft:8,
background:'#7c3aed'
}}
/>

)}

<DownOutlined style={{marginLeft:8}} />

</Button>

</Dropdown>

</div>



{/* EXPORT BUTTON RIGHT SIDE */}
<div style={{ marginLeft:'auto' }}>
<Button
type="primary"
icon={<DownloadOutlined />}
size="large"
onClick={() => setIsExportModalVisible(true)}
style={{
borderRadius:10,
paddingLeft:24,
paddingRight:24
}}
>

Export Leads

</Button>

</div>
</div>

</div>

<div
style={{
display:'flex',
alignItems:'center',
justifyContent:'space-between',

padding:'12px 16px',
border:'1px solid #e5e7eb',
borderRadius:8,
background:'#fff'
}}
>

<div>

{
selectedLeadIds.length > 0 ? (

<Button
size="small"
danger
onClick={() => {

setSelectedLeadIds([]);

message.success("Selection cleared");

}}
>

Unselect All ({selectedLeadIds.length})

</Button>

) : (

<Button
size="small"
onClick={() =>
setIsSelectAllModalVisible(true)
}
>

Select Leads

</Button>

)
}


{

selectedLeadIds.length>0 &&
!resultLoading && (

<Text
style={{
marginLeft:12,
color:'#7c3aed',
fontWeight:500
}}
>

{

selectedLeadIds.filter(
id=>
results.some(
lead=>lead.id===id
)
).length

}

 selected

</Text>

)

}

</div>



<div>

<span
style={{
fontSize:14,
color:'#374151'
}}
>

<strong>

{

resultLoading

?

'Searching...'

:

totalResults>=1000000

?

(totalResults/1000000).toFixed(1)+'M'

:

totalResults>=1000

?

(totalResults/1000).toFixed(1)+'K'

:

totalResults

}

</strong>

{

resultLoading

?

''

:

' Results found'

}

</span>

</div>

</div>



{/* LOADER */}

{resultLoading ? (

Array.from({length:6}).map((_,index)=>(

<Card
key={index}
bordered
style={{
borderRadius:16,
border:'1px solid #e5e7eb',
boxShadow:'0 1px 2px rgba(0,0,0,.05)',
padding:8
}}
bodyStyle={{
padding:20
}}
>

<div
style={{
display:'flex',
justifyContent:'space-between'
}}
>

<div
style={{
display:'flex',
gap:16,
flex:1
}}
>

<Skeleton.Avatar
active
size={56}
shape="circle"
/>

<div style={{flex:1}}>

<Skeleton.Input
active
style={{
width:220,
marginBottom:12
}}
/>

<Skeleton.Input
active
style={{
width:180
}}
/>

</div>

</div>

<Skeleton.Button active />

</div>


<div
style={{
marginTop:20
}}
>

<Skeleton
active
paragraph={{
rows:2
}}
title={false}
/>

</div>

</Card>

))

) : (

results.map((lead) => {
  const revealedEmail = revealedContacts[lead.id]?.email;
  const revealedPhone = revealedContacts[lead.id]?.mobile_phone;

  const buttonStyle = {
    height: 46,
    borderColor: '#9856F2',
    color: '#9856F2',
    borderRadius: 6,
    fontWeight: 500,
    fontSize: 14,
    minWidth: 135,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    padding: '0 14px',
  };

  const infoStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    color: '#374151',
  };

  const handleCopyOrReveal = (type, value) => {
    if (!value || String(value).trim() === '') {
      setRevealedContacts((prev) => ({
        ...prev,
        [lead.id]: {
          ...prev[lead.id],
          [type]: '__NOT_FOUND__',
        },
      }));
      message.warning(type === 'email' ? 'Email not found' : 'Phone not found');
      return;
    }

    handleReveal(lead.id, type, value);
  };

  return (
    <Card
      key={lead.id}
      bordered
      style={{
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        boxShadow: 'none',
        marginBottom: 12,
        background: '#fff',
      }}
      bodyStyle={{ padding: 0 }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '24px 24px 18px',
        }}
      >
        {/* LEFT */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
          <Checkbox
            checked={selectedLeadIds.includes(lead.id)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedLeadIds((prev) => [...prev, lead.id]);
              } else {
                setSelectedLeadIds((prev) =>
                  prev.filter((id) => id !== lead.id)
                );
              }
            }}
            style={{ marginTop: 14 }}
          />

          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: '#f3e8ff',
              color: '#9856F2',
              fontWeight: 600,
              fontSize: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {lead.first_name?.[0]?.toUpperCase()}
            {lead.last_name?.[0]?.toUpperCase()}
          </div>

          <div>
            <div style={{ fontWeight: 600, fontSize: 16, color: '#111827' }}>
              {lead.first_name} {lead.last_name}
            </div>

            <div
              style={{
                fontSize: 14,
                color: '#111827',
                marginTop: 4,
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <span>{lead.title || 'N/A'}</span>

              
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 46,
                marginTop: 24,
                flexWrap: 'wrap',
              }}
            >
              {/* EMAIL */}
             <div style={infoStyle}>
                <ApartmentOutlined
                  style={{ color: '#9856F2', fontSize: 18 }}
                />
                <span style={{ fontSize: 14, color: '#374151' }}>
                  {lead.company || 'N/A'}
                </span>
              </div>

              {/* LOCATION */}
              <div style={infoStyle}>
                <EnvironmentOutlined
                  style={{ color: '#9856F2', fontSize: 18 }}
                />
                <span style={{ fontSize: 14, color: '#374151' }}>
                  {lead.city || lead.company_city || 'N/A'}
                  {lead.country || lead.company_country
                    ? `, ${lead.country || lead.company_country}`
                    : ''}
                </span>
              </div>

              {/* LINKEDIN */}
              {lead.linkedin_url && (
                <a
                  href={lead.linkedin_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    ...infoStyle,
                    color: '#9856F2',
                    fontWeight: 500,
                    textDecoration: 'none',
                  }}
                  style={{fontSize: 14, color: '#374151', display: 'flex', alignItems: 'center', gap: 6}}
                >
                  <LinkedinFilled style={{ fontSize: 18 }} />
                  View on LinkedIn
                </a>
              )}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 9,
            alignItems: 'flex-end',
            marginLeft: 14,
          }}
        >
          {/* EMAIL BUTTON PLACE */}
          {revealedEmail ? (
            <Button
              size="small"
              icon={<CopyOutlined />}
              onClick={() =>
                revealedEmail !== '__NOT_FOUND__' &&
                copyText(revealedEmail, `${lead.id}-email-btn`)
              }
              style={buttonStyle}
            >
              {revealedEmail === '__NOT_FOUND__'
                ? 'Email Not Found'
                : copiedField[`${lead.id}-email-btn`]
                ? 'Copied'
                : revealedEmail}
            </Button>
          ) : (
            <Button
              size="small"
              icon={<MailOutlined />}
              loading={revealingIds[lead.id]?.email}
              onClick={() => handleCopyOrReveal('email', lead.email)}
              style={buttonStyle}
            >
              Click to Reveal
            </Button>
          )}

          {/* PHONE BUTTON PLACE */}
          {revealedPhone ? (
            <Button
              size="small"
              icon={<CopyOutlined />}
              onClick={() =>
                revealedPhone !== '__NOT_FOUND__' &&
                copyText(revealedPhone, `${lead.id}-mobile-btn`)
              }
              style={buttonStyle}
            >
              {revealedPhone === '__NOT_FOUND__'
                ? 'Phone Not Found'
                : copiedField[`${lead.id}-mobile-btn`]
                ? 'Copied'
                : revealedPhone}
            </Button>
          ) : (
            <Button
              size="small"
              icon={<PhoneOutlined />}
              loading={revealingIds[lead.id]?.mobile_phone}
              onClick={() =>
                handleCopyOrReveal('mobile_phone', lead.mobile_phone)
              }
              style={buttonStyle}
            >
              Click to Reveal
            </Button>
          )}
        </div>
      </div>

      {/* FOOTER */}
      <div
        style={{
          borderTop: '1px solid #f1f1f1',
          padding: '10px 18px',
          fontSize: 11,
          color: '#4b5563',
        }}
      >
        We used verified data sources.
      </div>
    </Card>
  );
})

)}
  </Space>
)}



{totalResults > pageSize && (

<div
style={{
display:'flex',
justifyContent:'center',
marginTop:32,
marginBottom:20
}}
>

<Pagination

current={currentPage}

pageSize={pageSize}

total={totalResults}

showSizeChanger

showQuickJumper

pageSizeOptions={[10,20,50,100]}

onChange={(page,size)=>{

setCurrentPage(page);

setPageSize(size);

executeSearch({

page,

limit:size

});

}}

onShowSizeChange={(page,size)=>{

setCurrentPage(1);

setPageSize(size);

executeSearch({

page:1,

limit:size

});

}}

/>

</div>

)}

</div>


        </Content>

        <Modal
  title="Export Leads"
  visible={isExportModalVisible}
  onOk={handleOk}
  onCancel={() => setIsExportModalVisible(false)}
  okText="Export"
  confirmLoading={exportLoading}
>
  <Form
form={form}
layout="vertical"
>

<Form.Item
label="Export Type"
>

<Radio.Group
value={exportMode}
onChange={(e)=>setExportMode(
e.target.value
)}
style={{
width:'100%'
}}
>

<Space
direction="vertical"
style={{
width:'100%'
}}
>

<Radio value="all">

<div>

<div
style={{
fontWeight:600
}}
>

Export All Leads

</div>

<div
style={{
fontSize:12,
color:'#666'
}}
>

Export results from search

</div>

</div>

</Radio>


<Radio value="selected">

<div>

<div
style={{
fontWeight:600
}}
>

Selected Leads Only

</div>

<div
style={{
fontSize:12,
color:'#666'
}}
>

{selectedLeadIds.length} selected

</div>

</div>

</Radio>

</Space>

</Radio.Group>

</Form.Item>


{/* COUNT ONLY FOR ALL */}

{exportMode==="all" && (

<Form.Item
label="Contact Count"
>

<Input
type="number"
min={1}
value={rowSelection}
onChange={(e)=>
setRowSelection(
e.target.value
)
}
/>

</Form.Item>

)}


<Form.Item
label="Include Data"
>

<Space direction="vertical">

<Checkbox
checked={includeEmail}
onChange={(e)=>
setIncludeEmail(
e.target.checked
)
}
>

Email

</Checkbox>


<Checkbox
checked={includeMobile}
onChange={(e)=>
setIncludeMobile(
e.target.checked
)
}
>

Mobile

</Checkbox>

</Space>

</Form.Item>

</Form>
</Modal>


<Modal

title="Select Leads"

open={isSelectAllModalVisible}

onCancel={()=>
setIsSelectAllModalVisible(false)
}

onOk={handleSelectAllOk}

confirmLoading={selectLoading}

okText="Select"

>

<Form layout="vertical">

<Form.Item label="Selection Type">

<Radio.Group

value={selectMode}

onChange={(e)=>
setSelectMode(
e.target.value
)
}

>

<Space direction="vertical">

<Radio value="page">

Select Current Page Results

</Radio>

<Radio value="count">

Select Number Of Leads

</Radio>

</Space>

</Radio.Group>

</Form.Item>


{

selectMode==="count"

&&

<Form.Item
label="Lead Count"
>

<Input

type="number"

min={1}

value={selectLeadCount}

onChange={(e)=>
setSelectLeadCount(
Number(
e.target.value
)
)
}

/>

</Form.Item>

}

</Form>

</Modal>

      </Layout>
    </Layout>
  );
}